angular.module('kareo.auth-configuration', ['kareo.environment', 'kareo.authentication'])
  .config([
    '$httpProvider', function ($httpProvider) {
      $httpProvider.interceptors.push('kareoAuthHttpResponseInterceptor');
    }])
  .run([
    '$rootScope', 'KareoEnvironment', 'authService', function ($rootScope, environment, authService) {
      var autoAuthEnabled = environment.autoAuth;
      var loggingIn = false;
      $rootScope.$on('event:auth-loginRequired', (event, redirectOk) => {
        login(redirectOk);
      });
      function login(redirectOk) {
        if (loggingIn) {
          return;
        }
        loggingIn = true;
        if (autoAuthEnabled) {
          autoAuth();
        } else {
          normalAuth(redirectOk);
        }
      }

      function autoAuth() {
        authService.reauth()
          .then(() => {
            loggingIn = false;
          });
      }

      function normalAuth(redirectOk) {
        authService.login(redirectOk);
      }
    }]);
